/* istanbul ignore file */
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggedInUserSettings } from '../services/settings/logged-in-user-settings';
import { dashboardRouteWithSlash } from 'src/app/core/core';

@Injectable({
  providedIn: 'root',
})
export class FeatureGuard {
  constructor(
    private loggedInUserSettings: LoggedInUserSettings,
    private location: Location,
    private router: Router
  ) {
  }

  canActivate(dealerCode, featureKey: string, isEnabledVal: boolean = null): boolean {
    const isEnabled = isEnabledVal != null ? isEnabledVal : this.loggedInUserSettings.isFeatureEnabled(dealerCode, featureKey);
    if (isEnabled) {
      return true;
    }
    else {
      this.goBack();
      return false;
    }
  }

  goBack() {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate([dashboardRouteWithSlash]);
    }
  }
}
